
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  // Auto-generate breadcrumbs from URL if items not provided
  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    if (items) return items;

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: 'Ana Sayfa', href: '/' }];

    // Map for Turkish labels
    const labelMap: Record<string, string> = {
      'fiber-hizmetleri': 'Fiber Optik Hizmetleri',
      'guvenlik-sistemleri': 'Güvenlik Sistemleri',
      'bolgeler': 'Hizmet Bölgeleri',
      'blog': 'Blog',
      'fiber-kablo-tamiri': 'Fiber Kablo Tamiri',
      'fiber-sonlandirma': 'Fiber Sonlandırma',
      'otdr-test': 'OTDR Test',
      'bina-fiber-altyapi': 'Bina Fiber Altyapı',
      'fabrika-fiber': 'Fabrika Fiber Çözümleri',
      'acil-servis': '7/24 Acil Servis',
      'ip-kamera': 'IP Kamera Sistemleri',
      'hirsiz-alarm': 'Hırsız Alarm Sistemleri',
      'yangin-alarm': 'Yangın Alarm Sistemleri',
      'gecis-kontrol': 'Geçiş Kontrol Sistemleri',
      'bariyer': 'Bariyer Sistemleri',
      'turnike': 'Turnike Sistemleri',
      'istanbul-avrupa': 'İstanbul Avrupa Yakası',
      'istanbul-anadolu': 'İstanbul Anadolu Yakası',
      'tuzla': 'Tuzla',
      'gebze': 'Gebze',
      'dilovasi': 'Dilovası',
      'cayirova': 'Çayırova',
      'kocaeli': 'Kocaeli',
      'sakarya': 'Sakarya',
      'yalova': 'Yalova',
      'bursa': 'Bursa',
      'tekirdag': 'Tekirdağ',
      'corlu': 'Çorlu',
      'atasehir': 'Ataşehir',
      'kadikoy': 'Kadıköy',
      'umraniye': 'Ümraniye',
      'esenyurt': 'Esenyurt',
      'basaksehir': 'Başakşehir',
      'pendik': 'Pendik',
      'kartal': 'Kartal',
      'beylikduzu': 'Beylikdüzü',
    };

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = labelMap[segment] || segment.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      breadcrumbs.push({
        label,
        href: index === pathSegments.length - 1 ? undefined : currentPath,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbItems = generateBreadcrumbs();

  if (breadcrumbItems.length <= 1) return null;

  return (
    <nav className="py-4 px-4 bg-slate-900/50 border-b border-slate-800" aria-label="Breadcrumb">
      <div className="container mx-auto">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          {breadcrumbItems.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-gray-600"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-teal-400 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
